import {Component, HostBinding, NgZone, OnDestroy, OnInit} from '@angular/core';
import {DataService, ParkingDeck} from './services/data.service';
import {animate, animateChild, query, state, style, transition, trigger} from '@angular/animations';
import {Observable, Subscription} from 'rxjs';
import {ignoreElements, map, takeUntil} from 'rxjs/operators';
import {BreakpointObserver} from '@angular/cdk/layout';
import {MatDialog, MatIconRegistry} from '@angular/material';
import {AboutDialogComponent} from './about-dialog/about-dialog.component';
import {DisclaimerComponent} from './disclaimer/disclaimer.component';
import {fadeInOut} from './animations';
import {DomSanitizer} from '@angular/platform-browser';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    fadeInOut
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  public constructor(public dataService: DataService,
                     private breakpointObserver: BreakpointObserver,
                     public dialog: MatDialog) {
    this.favCount = dataService.favParkingData$.pipe(map(lst => lst.length > 0));
    this.unfavCount = dataService.unfavParkingData$.pipe(map(lst => lst.length > 0));
    dataService.isLive.pipe(
      takeUntil(this.favCount.pipe(ignoreElements()))
    ).subscribe(live => this.isLive = live);
  }

  favCount: Observable<boolean>;
  unfavCount: Observable<boolean>;
  isLive: boolean;

  @HostBinding('class.desktop') isDesktopUI: boolean;
  private breakpointSubscription: Subscription;

  toggleFavorite(deck: ParkingDeck, index: number): void {
    deck.favorite = !deck.favorite;

    if (deck.favorite) {
      this.dataService.saveFavorite(deck);
      gtag('event', 'favorite', {
        'event_category': 'engagement',
        'event_label': deck.name
      });
    } else {
      this.dataService.removeFavorite(deck);
      gtag('event', 'unfavorite', {
        'event_category': 'engagement',
        'event_label': deck.name
      });
    }
  }

  trackByFn(index: number, deck: ParkingDeck): string {
    return deck ? deck.lotCode : '0';
  }


  ngOnInit(): void {
    this.breakpointSubscription = this.breakpointObserver.observe('(min-width: 767px)')
      .subscribe(result => this.isDesktopUI = result.matches);

    if ('localStorage' in window) {
      const firstRun = !window.localStorage.getItem('firstRun');

      if (firstRun && /android|iphone|ipad/i.test(window.navigator.userAgent)) {

        setTimeout(() => {
          const dialogRef = this.dialog.open(DisclaimerComponent, {
            closeOnNavigation: false,
            disableClose: true
          });
          dialogRef.afterClosed().subscribe(data => {
            window.localStorage.setItem('firstRun', 'true');
          });
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.breakpointSubscription.unsubscribe();
  }

  showAbout() {
    this.dialog.open(AboutDialogComponent);
  }
}
